'use client';

export {};

declare global {
  interface Window {
    tgp: (action: string, id: string) => void;
  }
}

import { useMutation } from '@apollo/client/react';

import React, { FC } from 'react';

import { SEND_KEYBOARD } from '@/.graphql';
import { useGTMContext } from '@/src/providers';
import { miniApp } from '@tma.js/sdk-react';

const styles = {
  button:
    'sticky bottom-10 w-full left-5 right-5 bg-fill-button rounded-xl py-5 mt-8 block cursor-pointer',

  buttonText: 'text-label-black font-extrabold text-base text-center',
};

interface CloseAppButtonProps {
  text: string;
  keybord: string;
}

export const CloseAppButton: FC<CloseAppButtonProps> = ({ text, keybord }) => {
  const [sendKeyboard] = useMutation(SEND_KEYBOARD);
  const sendGTM = useGTMContext();

  const onCloseWebApp = async () => {
    try {
      await sendKeyboard({
        variables: {
          keyboard: keybord,
        },
      });

      if (keybord === 'paymentDownSale4') {
        if (typeof window !== 'undefined' && typeof window.tgp === 'function') {
          window.tgp('event', '7T4zQojL-DDTj064F');
        }
        sendGTM({
          event: 'Pay_popap_free',
        });
      }

      if (miniApp.close.isAvailable()) {
        miniApp.close();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <button className={styles.button} onClick={onCloseWebApp}>
      <div className={styles.buttonText}>{text}</div>
    </button>
  );
};
